/* tslint:disable */

import { defineMessages } from 'react-intl';

export const scope = 'app.utils';

export default defineMessages({
  callUs: {
    id: `${scope}.callUs`,
    defaultMessage: 'Gọi chúng tôi',
  },
  collection: {
    id: `${scope}.collection`,
    defaultMessage: 'Bộ sưu tập',
  },
  deliveryAddress: {
    id: `${scope}.deliveryAddress`,
    defaultMessage: 'Địa chỉ giao hàng',
  },
  deliveryNote: {
    id: `${scope}.deliveryNote`,
    defaultMessage: 'Ghi chú (Không bắt buộc)',
  },
  deliveryNotePlaceholder: {
    id: `${scope}.deliveryNotePlaceholder`,
    defaultMessage: 'VD: Giao tầng 2 / Giao cửa sau',
  },
  SUPER_COMBO: {
    id: `${scope}.SUPER_COMBO`,
    defaultMessage: 'Combo Ưu Đãi 🎁',
  },
  VEGETABLE_SUPER_SAVING: {
    id: `${scope}.VEGETABLE_SUPER_SAVING`,
    defaultMessage: '🍋 Rau Củ 10Kg Siêu Tiết Kiệm 🥕💰',
  },
  TORANI: {
    id: `${scope}.TORANI`,
    defaultMessage: 'Torani 🍯🍧',
  },
  CP_PRODUCTS: {
    id: `${scope}.CP_PRODUCTS`,
    defaultMessage: 'Thương Hiệu CP',
  },
  VINAMILK_DALAT_MILK: {
    id: `${scope}.VINAMILK_DALAT_MILK`,
    defaultMessage: 'Sữa Vinamilk & Sữa Dalat Milk 🥛🐄',
  },
  JAPANESE_PRODUCTS: {
    id: `${scope}.JAPANESE_PRODUCTS`,
    defaultMessage: '🇯🇵 Sản Phẩm Nhật Bản 🇯🇵',
  },
  BEST_PRICES: {
    id: `${scope}.BEST_PRICES`,
    defaultMessage: 'Giá Tốt Tuần Này',
  },
  BEST_DEALS: {
    id: `${scope}.BEST_DEALS`,
    defaultMessage: 'Siêu Khuyến Mãi',
  },
  FLASH_SALES: {
    id: `${scope}.FLASH_SALES`,
    defaultMessage: '⚡ Flash Sale 🔥',
  },
  NEW_PRODUCTS: {
    id: `${scope}.NEW_PRODUCTS`,
    defaultMessage: 'Sản Phẩm Mới',
  },
  MEAT_ZERO: {
    id: `${scope}.MEAT_ZERO`,
    defaultMessage: 'Meat Zero 🌱',
  },
  FRUITS: {
    id: `${scope}.FRUITS`,
    defaultMessage: 'Trái Cây 🍇🍉',
  },
  LETTUCE: {
    id: `${scope}.LETTUCE`,
    defaultMessage: 'Xà Lách 🥬 🥗',
  },
  RECOMMENDED_FOR_YOU: {
    id: `${scope}.RECOMMENDED_FOR_YOU`,
    defaultMessage: 'Sản phẩm đề xuất',
  },
  BOOK_IN_ADVANCE: {
    id: `${scope}.BOOK_IN_ADVANCE`,
    defaultMessage: 'Hàng Đặt Trước 📅✍️',
  },
  DISHWASHING_LIQUID: {
    id: `${scope}.DISHWASHING_LIQUID`,
    defaultMessage: 'Nước rửa chén Kamereo',
  },
  RAU_CU_QUA_TRUNG_QUOC: {
    id: `${scope}.RAU_CU_QUA_TRUNG_QUOC`,
    defaultMessage: 'Rau Củ Quả Trung Quốc 🇨🇳🥦',
  },
  TRAI_CAY_NOI_DIA: {
    id: `${scope}.TRAI_CAY_NOI_DIA`,
    defaultMessage: '🥥 Trái Cây Nội Địa 🍉🍌🍍',
  },
  TRAI_CAY_NHAP_KHAU: {
    id: `${scope}.TRAI_CAY_NHAP_KHAU`,
    defaultMessage: '🍒 Trái Cây Nhập Khẩu 🍒🍎🍇',
  },
  THUONG_HIEU_KAMEREO: {
    id: `${scope}.THUONG_HIEU_KAMEREO`,
    defaultMessage: 'Thương Hiệu Kamereo 🏷️ ',
  },
  NAM_TUOI_NGON: {
    id: `${scope}.NAM_TUOI_NGON`,
    defaultMessage: 'Nấm Tươi Ngon 🍄',
  },
  THAN_THIEN_MOI_TRUONG: {
    id: `${scope}.THAN_THIEN_MOI_TRUONG`,
    defaultMessage: 'Thân Thiện Môi Trường ♻️ 🌿♻️',
  },
  NGUYEN_LIEU_PHA_CHE: {
    id: `${scope}.NGUYEN_LIEU_PHA_CHE`,
    defaultMessage: 'Nguyên Liệu Pha Chế 🍹🍸',
  },
  NGUYEN_LIEU_LAM_BANH: {
    id: `${scope}.NGUYEN_LIEU_LAM_BANH`,
    defaultMessage: '🍰 Nguyên Liệu Làm Bánh 🍰 🧁🥖',
  },
  AJINOMOTO_GIA_TOT: {
    id: `${scope}.AJINOMOTO_GIA_TOT`,
    defaultMessage: 'Sản Phẩm Ajinomoto 🍜',
  },
  HAI_SAN: {
    id: `${scope}.HAI_SAN`,
    defaultMessage: 'Sản Phẩm Hải Sản 🦞🐟',
  },
  HEO_BO_GIA_SUC: {
    id: `${scope}.HEO_BO_GIA_SUC`,
    defaultMessage: 'Sản Phẩm Gia Súc 🥩🍖',
  },
  GA_VIT_GIA_CAM: {
    id: `${scope}.GA_VIT_GIA_CAM`,
    defaultMessage: 'Sản Phẩm Gia Cầm 🍗🐔',
  },
  RAU_CU_QUA_DA_LAT: {
    id: `${scope}.RAU_CU_QUA_DA_LAT`,
    defaultMessage: '🌻 Rau Củ Quả Đà Lạt 🍓🏞️',
  },
  UU_DAI: {
    id: `${scope}.UU_DAI`,
    defaultMessage: 'Ưu Đãi 🎉',
  },
  TOP_PICK: {
    id: `${scope}.TOP_PICK`,
    defaultMessage: 'Lựa Chọn Hàng Đầu ⭐',
  },
  BEST_CHOICE: {
    id: `${scope}.BEST_CHOICE`,
    defaultMessage: 'Lựa Chọn Tốt Nhất 🏆',
  },
  GYOMU_SUPER: {
    id: `${scope}.GYOMU_SUPER`,
    defaultMessage: 'Gyomu Japan - Hàng Nhật Nội Địa 🇯🇵📦',
  },
  NHA_HANG_VIET: {
    id: `${scope}.NHA_HANG_VIET`,
    defaultMessage: 'Dành Cho Nhà Hàng Việt 🍜🇻🇳',
  },
  NHA_HANG_TAY: {
    id: `${scope}.NHA_HANG_TAY`,
    defaultMessage: 'Dành Cho Nhà Hàng Tây 🍔🍝',
  },
  NHA_HANG_NHAT_BAN: {
    id: `${scope}.NHA_HANG_NHAT_BAN`,
    defaultMessage: 'Dành Cho Nhà Hàng Nhật Bản 🍣🍱',
  },
  QUAN_AN_HAN_QUOC: {
    id: `${scope}.QUAN_AN_HAN_QUOC`,
    defaultMessage: 'Dành Cho Nhà Hàng Hàn Quốc 🍲🇰🇷',
  },
  NHA_HANG_TRUNG_HOA: {
    id: `${scope}.NHA_HANG_TRUNG_HOA`,
    defaultMessage: 'Dành Cho Nhà Hàng Trung Hoa 🥢🥡',
  },
  QUAN_AN_THAI_LAN: {
    id: `${scope}.QUAN_AN_THAI_LAN`,
    defaultMessage: 'Dành Cho Nhà Hàng Thái Lan 🍛🇹🇭',
  },
  NHA_HANG_CHAY: {
    id: `${scope}.NHA_HANG_CHAY`,
    defaultMessage: 'Dành Cho Nhà Hàng Chay 🥗🥒',
  },
  DANH_CHO_BAR_PUB_CLUB: {
    id: `${scope}.DANH_CHO_BAR_PUB_CLUB`,
    defaultMessage: 'Dành Cho Bar - Pub - Club 🍻🍷',
  },
  DANH_CHO_KHACH_SAN: {
    id: `${scope}.DANH_CHO_KHACH_SAN`,
    defaultMessage: 'Dành Cho Khách Sạn 🏨🛎️',
  },
  CUA_HANG_TIEN_LOI: {
    id: `${scope}.CUA_HANG_TIEN_LOI`,
    defaultMessage: 'Dành Cho Cửa Hàng Tiện Lợi 🛒🏪',
  },
  DANH_CHO_SIEU_THI: {
    id: `${scope}.DANH_CHO_SIEU_THI`,
    defaultMessage: 'Dành Cho Siêu Thị 🛍️🛒',
  },
  CUA_HANG_BAN_LE: {
    id: `${scope}.CUA_HANG_BAN_LE`,
    defaultMessage: 'Dành Cho Cửa Hàng Bán Lẻ 🛍️🏬',
  },
  CUA_HANG_TAP_HOA: {
    id: `${scope}.CUA_HANG_TAP_HOA`,
    defaultMessage: 'Dành Cho Cửa Hàng Tạp Hóa 🍞🥛',
  },
  CUA_HANG_TRUC_TUYEN: {
    id: `${scope}.CUA_HANG_TRUC_TUYEN`,
    defaultMessage: 'Dành Cho Cửa Hàng Trực Tuyến 💻📦',
  },
  CATERING_CANTEEN_CAN_TIN: {
    id: `${scope}.CATERING_CANTEEN_CAN_TIN`,
    defaultMessage: 'Dành Cho Căn Tin 🍽️🥗',
  },
  NHA_MAY_XI_NGHIEP: {
    id: `${scope}.NHA_MAY_XI_NGHIEP`,
    defaultMessage: 'Dành Cho Nhà Máy - Xí Nghiệp 🏭',
  },
  TRUONG_HOC: {
    id: `${scope}.TRUONG_HOC`,
    defaultMessage: 'Dành Cho Trường Học 🎒📚',
  },
  BENH_VIEN: {
    id: `${scope}.BENH_VIEN`,
    defaultMessage: 'Dành Cho Bệnh Viện 🏥💉',
  },
  VAN_PHONG: {
    id: `${scope}.VAN_PHONG`,
    defaultMessage: 'Dành Cho Văn Phòng 🖇️💼',
  },
  PHONG_TAP_GYM: {
    id: `${scope}.PHONG_TAP_GYM`,
    defaultMessage: 'Dành Cho Phòng Tập Gym 🏋️‍♀️🤸‍♂️',
  },
  TRUNG_TAM_SU_KIEN: {
    id: `${scope}.TRUNG_TAM_SU_KIEN`,
    defaultMessage: 'Dành Cho Trung Tâm Sự Kiện 🎫🏟️',
  },
  AN_NHAU: {
    id: `${scope}.AN_NHAU`,
    defaultMessage: 'Dành Cho Quán Ăn Nhậu 🍻🍖',
  },
  QUAN_AN_VIET: {
    id: `${scope}.QUAN_AN_VIET`,
    defaultMessage: 'Dành Cho Quán Ăn Việt 🍜🇻🇳',
  },
  CAO_CAP: {
    id: `${scope}.CAO_CAP`,
    defaultMessage: 'Sản Phẩm Cao Cấp 🥇',
  },
  NHAP_KHAU: {
    id: `${scope}.NHAP_KHAU`,
    defaultMessage: 'Sản Phẩm Nhập Khẩu 🌍✈️',
  },
  HOA_TRANG_TRI: {
    id: `${scope}.HOA_TRANG_TRI`,
    defaultMessage: 'Hoa Trang Trí 🌸 💐🌷',
  },
  RAU_CU_QUA_MIEN_TAY: {
    id: `${scope}.RAU_CU_QUA_MIEN_TAY`,
    defaultMessage: 'Rau Củ Quả Miền Tây 🌾🍠',
  },
  mart: {
    id: `${scope}.mart`,
    defaultMessage: 'Chợ',
  },
  accountCreatedSuccessfully: {
    id: `${scope}.accountCreateSuccessfully`,
    defaultMessage: 'Tài khoản đã được tạo thành công!',
  },
  basicInfo: {
    id: `${scope}.basicInfo`,
    defaultMessage: 'Thông Tin Cơ bản',
  },
  print: {
    id: `${scope}.print`,
    defaultMessage: 'Xuất PDF',
  },
  printing: {
    id: `${scope}.printing`,
    defaultMessage: 'Chúng tôi đang xử lý file PDF. Vui lòng trở lại sau 1 phút.',
  },
  fieldRequired: {
    id: `${scope}.fieldRequired`,
    defaultMessage: '{field} không được để trống.',
  },
  fieldWardRequired: {
    id: `${scope}.fieldWardRequired`,
    defaultMessage: 'Vui lòng chọn phường/xã.',
  },
  fieldEmail: {
    id: `${scope}.fieldEmail`,
    defaultMessage: 'Vui lòng nhập đúng địa chỉ email!',
  },
  optional: {
    id: `${scope}.optional`,
    defaultMessage: 'Tùy chọn',
  },
  incompleteAddressInput: {
    id: `${scope}.incompleteAddressInput`,
    defaultMessage: 'Vui lòng cập nhật địa chỉ.',
  },
  presevationAll: {
    id: `${scope}.presevationAll`,
    defaultMessage: 'Mọi điều kiện',
  },
  presevationRefrigerated: {
    id: `${scope}.presevationRefrigerated`,
    defaultMessage: 'Tủ mát',
  },
  presevationFrozen: {
    id: `${scope}.presevationFrozen`,
    defaultMessage: 'Tủ đông',
  },
  presevationRoomTemperature: {
    id: `${scope}.presevationRoomTemperature`,
    defaultMessage: 'Nhiệt độ phòng',
  },
  username: {
    id: `${scope}.username`,
    defaultMessage: 'Tên Đăng Nhập',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Số Điện Thoại',
  },
  orderId: {
    id: `${scope}.orderId`,
    defaultMessage: 'Mã đơn hàng',
  },
  ffmNoteId: {
    id: `${scope}.ffmNoteId`,
    defaultMessage: 'Mã phiếu giao',
  },
  add: {
    id: `${scope}.add`,
    defaultMessage: 'Thêm',
  },
  addAll: {
    id: `${scope}.addAll`,
    defaultMessage: 'Thêm tất cả',
  },
  change: {
    id: `${scope}.change`,
    defaultMessage: 'Cập nhật',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Lưu',
  },
  confirm: {
    id: `${scope}.confirm`,
    defaultMessage: 'Xác nhận',
  },
  close: {
    id: `${scope}.close`,
    defaultMessage: 'Đóng',
  },
  readMoreAboutUs: {
    id: `${scope}.readMoreAboutUs`,
    defaultMessage: 'Tìm hiểu thêm về chúng tôi',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Huỷ',
  },
  finish: {
    id: `${scope}.finish`,
    defaultMessage: 'Hoàn tất',
  },
  makeOrder: {
    id: `${scope}.makeOrder`,
    defaultMessage: 'Đặt hàng',
  },
  paymentInfo: {
    id: `${scope}.paymentInfo`,
    defaultMessage: 'Thông tin thanh toán',
  },
  send: {
    id: `${scope}.send`,
    defaultMessage: 'Gửi mẫu đăng ký',
  },
  placeholder_district: {
    id: `${scope}.placeholder_district`,
    defaultMessage: 'Chọn quận',
  },
  placeholder_city: {
    id: `${scope}.placeholder_city`,
    defaultMessage: 'Chọn thành phố',
  },
  placeholder_branch: {
    id: `${scope}.placeholder_branch`,
    defaultMessage: 'Chọn cửa hàng',
  },
  placeholder_search: {
    id: `${scope}.placeholder_search`,
    defaultMessage: 'Tìm kiếm địa chỉ',
  },
  district: {
    id: `${scope}.district`,
    defaultMessage: 'Quận',
  },
  city: {
    id: `${scope}.city`,
    defaultMessage: 'Thành phố',
  },
  branch: {
    id: `${scope}.branch`,
    defaultMessage: 'Chi nhánh',
  },
  redInvoiceInfo: {
    id: `${scope}.redInvoiceInfo`,
    defaultMessage: 'Thông tin hoá đơn đỏ',
  },
  remove: {
    id: `${scope}.remove`,
    defaultMessage: 'Xoá',
  },
  uploadImage: {
    id: `${scope}.uploadImage`,
    defaultMessage: 'Chọn hình ảnh',
  },
  editInfo: {
    id: `${scope}.editInfo`,
    defaultMessage: 'Chỉnh sửa thông tin',
  },
  taxCode: {
    id: `${scope}.taxCode`,
    defaultMessage: 'Mã số thuế',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'Địa chỉ',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Tên',
  },
  fullName: {
    id: `${scope}.fullName`,
    defaultMessage: 'Họ và tên',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Trạng thái',
  },
  uom: {
    id: `${scope}.uom`,
    defaultMessage: 'Đơn vị',
  },
  availability: {
    id: `${scope}.availability`,
    defaultMessage: 'Trạng thái',
  },
  inStock: {
    id: `${scope}.inStock`,
    defaultMessage: 'Còn hàng',
  },
  outStock: {
    id: `${scope}.outStock`,
    defaultMessage: 'Hết hàng',
  },
  origin: {
    id: `${scope}.origin`,
    defaultMessage: 'Xuất xứ',
  },
  preservation: {
    id: `${scope}.preservation`,
    defaultMessage: 'Bảo quản',
  },
  supplier: {
    id: `${scope}.supplier`,
    defaultMessage: 'Nhà cung cấp',
  },
  category: {
    id: `${scope}.category`,
    defaultMessage: 'Danh mục',
  },
  addToCart: {
    id: `${scope}.addToCart`,
    defaultMessage: 'Thêm vào giỏ',
  },
  signin: {
    id: `${scope}.signin`,
    defaultMessage: 'Đăng nhập',
  },
  backto: {
    id: `${scope}.backto`,
    defaultMessage: 'Quay lại',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Quay lại',
  },
  reset: {
    id: `${scope}.reset`,
    defaultMessage: 'Gửi',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'email',
  },
  vat: {
    id: `${scope}.vat`,
    defaultMessage: 'VAT',
  },
  vatProductPrice: {
    id: `${scope}.vatProductPrice`,
    defaultMessage: 'Đã bao gồm VAT',
  },
  vatNotIncluded: {
    id: `${scope}.vatNotIncluded`,
    defaultMessage: 'Chưa bao gồm VAT',
  },
  done: {
    id: `${scope}.done`,
    defaultMessage: 'Hoàn tất!',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Mật Khẩu',
  },
  businessName: {
    id: `${scope}.businessName`,
    defaultMessage: 'Tên Doanh Nghiệp',
  },
  businessNamePlaceHolder: {
    id: `${scope}.businessNamePlaceHolder`,
    defaultMessage: 'Tên nhà hàng, khách sạn, cà phê,...',
  },
  companyName: {
    id: `${scope}.companyName`,
    defaultMessage: 'Tên Công Ty',
  },
  emailToReceiveEInvoice: {
    id: `${scope}.emailToReceiveEInvoice`,
    defaultMessage: 'Email để nhận hoá đơn điện tử',
  },
  getVATInvoiceOrNot: {
    id: `${scope}.getVATInvoiceOrNot`,
    defaultMessage: 'Nhận thông tin hoá đơn',
  },
  signup: {
    id: `${scope}.signup`,
    defaultMessage: 'Đăng ký',
  },
  passwordConfirmation: {
    id: `${scope}.passwordConfirmation`,
    defaultMessage: 'nhập lại mật khẩu',
  },
  moq: {
    id: `${scope}.moq`,
    defaultMessage: 'Đơn tối thiểu',
  },
  viewDetail: {
    id: `${scope}.viewDetail`,
    defaultMessage: 'Xem chi tiết',
  },
  supplierName: {
    id: `${scope}.supplierName`,
    defaultMessage: 'Nhà cung cấp',
  },
  underMOQError: {
    id: `${scope}.underMOQError`,
    defaultMessage: 'Đơn hàng dưới giá trị tối thiểu',
  },
  underFreeShipMOQMessage: {
    id: `${scope}.underFreeShipMOQMessage`,
    defaultMessage: 'Với những hóa đơn dưới {moq}, Kamereo sẽ tính thêm phụ phí giao hàng là {fee}.',
  },
  freeShipMessage: {
    id: `${scope}.freeShipMessage`,
    defaultMessage: 'Đơn hàng của bạn được miễn phí vận chuyển 🎉',
  },
  shippingFeeNote: {
    id: `${scope}.shippingFeeNote`,
    defaultMessage: '(Chưa bao gồm {fee} phí giao hàng)',
  },
  deliveryPolicyMessage: {
    id: `${scope}.deliveryPolicyMessage`,
    defaultMessage: `Các đơn từ cùng cửa hàng có cùng ngày giao sẽ được gộp lại thành một lần giao hàng.`,
  },
  shippingFeePolicyMessage: {
    id: `${scope}.shippingFeePolicyMessage`,
    defaultMessage: `Nếu tổng các hóa đơn dưới {thres}, Kamereo sẽ tính thêm phụ phí giao hàng là {fee}.`,
  },
  cartTotal: {
    id: `${scope}.cartTotal`,
    defaultMessage: 'Tiền hàng',
  },
  cartDetails: {
    id: `${scope}.cartDetails`,
    defaultMessage: 'Giỏ hàng',
  },
  voucherText: {
    id: `${scope}.voucherText`,
    defaultMessage: 'Voucher',
  },
  voucherLabel: {
    id: `${scope}.voucherLabel`,
    defaultMessage: 'Kamereo voucher',
  },
  voucherButton: {
    id: `${scope}.voucherButton`,
    defaultMessage: 'Chọn hoặc nhập mã',
  },
  voucherApplied: {
    id: `${scope}.voucherApplied`,
    defaultMessage: 'Đã áp dụng',
  },
  voucherInvalid: {
    id: `${scope}.voucherInvalid`,
    defaultMessage: 'Voucher không thể sử dụng',
  },
  voucherValue: {
    id: `${scope}.voucherValue`,
    defaultMessage: 'Giảm giá',
  },
  deliveryDetails: {
    id: `${scope}.deliveryDetails`,
    defaultMessage: 'Giao hàng',
  },
  summary: {
    id: `${scope}.summary`,
    defaultMessage: 'Chốt đơn hàng',
  },
  next: {
    id: `${scope}.next`,
    defaultMessage: 'Tiếp tục',
  },
  itemImage: {
    id: `${scope}.itemImage`,
    defaultMessage: 'Hình ảnh',
  },
  itemName: {
    id: `${scope}.itemName`,
    defaultMessage: 'sản phẩm',
  },
  price: {
    id: `${scope}.price`,
    defaultMessage: 'Giá',
  },
  ward: {
    id: `${scope}.ward`,
    defaultMessage: 'Phường',
  },
  writeANote: {
    id: `${scope}.writeANote`,
    defaultMessage: 'Ghi chú (hoặc lý do bạn muốn thay đổi đơn hàng)',
  },
  unitPrice: {
    id: `${scope}.unitPrice`,
    defaultMessage: 'Đơn giá',
  },
  unitPriceExclVAT: {
    id: `${scope}.unitPriceExclVAT`,
    defaultMessage: 'Đơn giá (Trước VAT)',
  },
  excludeVAT: {
    id: `${scope}.excludeVAT`,
    defaultMessage: 'không VAT',
  },
  actualPrice: {
    id: `${scope}.actualPrice`,
    defaultMessage: 'Giá',
  },
  includeVAT: {
    id: `${scope}.includeVAT`,
    defaultMessage: 'có VAT',
  },
  deliveredPrice: {
    id: `${scope}.deliveredPrice`,
    defaultMessage: 'Giá đã giao',
  },
  quantity: {
    id: `${scope}.quantity`,
    defaultMessage: 'Số lượng',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Tổng tiền',
  },
  totalInclVAT: {
    id: `${scope}.totalInclVAT`,
    defaultMessage: 'Tổng tiền (có VAT)',
  },
  numberOfItems: {
    id: `${scope}.numberOfItems`,
    defaultMessage: 'Tổng cộng {count} sản phẩm',
  },
  deleteAllItems: {
    id: `${scope}.deleteAllItems`,
    defaultMessage: 'Bỏ toàn bộ sản phẩm',
  },
  totalItem: {
    id: `${scope}.totalItem`,
    defaultMessage: 'Tổng số sản phẩm',
  },
  items: {
    id: `${scope}.items`,
    defaultMessage: 'sản phẩm',
  },
  earliest: {
    id: `${scope}.earliest`,
    defaultMessage: 'sớm nhất',
  },
  paymentMethod: {
    id: `${scope}.paymentMethod`,
    defaultMessage: 'Phương thức thanh toán: ',
  },
  orderNowForEarliestDelivery: {
    id: `${scope}.orderNowForEarliestDelivery`,
    defaultMessage: 'Đặt hàng ngay để được giao hàng sớm nhất',
  },
  noteForDelivery: {
    id: `${scope}.noteForDelivery`,
    defaultMessage: 'Ghi chú giao hàng',
  },
  addNote: {
    id: `${scope}.addNote`,
    defaultMessage: 'Thêm ghi chú',
  },
  note: {
    id: `${scope}.note`,
    defaultMessage: 'Ghi chú',
  },
  accountSetting: {
    id: `${scope}.accountSetting`,
    defaultMessage: 'Thiết lập tài khoản',
  },
  signout: {
    id: `${scope}.signout`,
    defaultMessage: 'Đăng xuất',
  },
  yes: {
    id: `${scope}.yes`,
    defaultMessage: 'Đồng ý',
  },
  no: {
    id: `${scope}.no`,
    defaultMessage: 'Không',
  },
  congrats: {
    id: `${scope}.congrats`,
    defaultMessage: 'Chúc mừng',
  },
  deliveryDate: {
    id: `${scope}.deliveryDate`,
    defaultMessage: 'Ngày giao',
  },
  deliveryTime: {
    id: `${scope}.deliveryTime`,
    defaultMessage: 'Lúc',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Tìm kiếm',
  },
  in: {
    id: `${scope}.in`,
    defaultMessage: 'Trong',
  },
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Ngày bắt đầu',
  },
  endDate: {
    id: `${scope}.endDate`,
    defaultMessage: 'Ngày kết thúc',
  },
  fromDate: {
    id: `${scope}.fromDate`,
    defaultMessage: 'Từ ngày',
  },
  toDate: {
    id: `${scope}.toDate`,
    defaultMessage: 'Đến ngày',
  },
  removeFavoriteMessage: {
    id: `${scope}.removeFavoriteMessage`,
    defaultMessage: 'Bạn có chắc muốn bỏ sản phẩm này ra khỏi danh mục yêu thích?',
  },
  favorite: {
    id: `${scope}.favorite`,
    defaultMessage: 'Yêu thích?',
  },
  askAgain: {
    id: `${scope}.askAgain`,
    defaultMessage: 'Không hỏi lại',
  },
  sentryError: {
    id: `${scope}.sentryError`,
    defaultMessage: 'Đã có lỗi xảy ra.',
  },
  sentryReportFeedback: {
    id: `${scope}.sentryReportFeedback`,
    defaultMessage: 'Phản hồi cho chúng tôi.',
  },
  sentryTitle: {
    id: `${scope}.sentryTitle`,
    defaultMessage: 'Có lỗi xảy ra.',
  },
  sentrySubtitle: {
    id: `${scope}.sentrySubtitle`,
    defaultMessage: 'Phản hồi cho chúng tôi.',
  },
  sentrySubtitle2: {
    id: `${scope}.sentrySubtitle2`,
    defaultMessage: 'Bạn có thể cho chúng tôi biết chuyện gì đã xảy ra.',
  },
  sentryLabelName: {
    id: `${scope}.sentryLabelName`,
    defaultMessage: 'Tên',
  },
  sentryLabelEmail: {
    id: `${scope}.sentryLabelEmail`,
    defaultMessage: 'Email',
  },
  sentryLabelComments: {
    id: `${scope}.sentryLabelComments`,
    defaultMessage: 'Bạn đã làm gì?',
  },
  sentryLabelClose: {
    id: `${scope}.sentryLabelClose`,
    defaultMessage: 'Đóng',
  },
  sentryLabelSubmit: {
    id: `${scope}.sentryLabelSubmit`,
    defaultMessage: 'Gửi',
  },
  sentryErrorGeneric: {
    id: `${scope}.sentryErrorGeneric`,
    defaultMessage: 'Đã có vấn đề khi gửi lỗi. Thử lại',
  },
  sentryErrorFormEntry: {
    id: `${scope}.sentryErrorFormEntry`,
    defaultMessage: 'Có vài trường không hợp lệ. Bạn cần cập nhật lại.',
  },
  sentrySuccessMessage: {
    id: `${scope}.sentrySuccessMessage`,
    defaultMessage: 'Phản hồi của bạn đã được gửi. Cảm ơn bạn rất nhiều!',
  },
  goToMart: {
    id: `${scope}.goToMart`,
    defaultMessage: 'Vào chợ',
  },
  supplierAll: {
    id: `${scope}.supplierAll`,
    defaultMessage: 'Tất cả nhà cung cấp',
  },
  supplierOrdered: {
    id: `${scope}.supplierOrdered`,
    defaultMessage: 'Chỉ nhà cung cấp có đơn hàng',
  },
  supplierFavorite: {
    id: `${scope}.supplierFavorite`,
    defaultMessage: 'Chỉ nhà cung cấp được yêu thích',
  },
  sameDay: {
    id: `${scope}.sameDay`,
    defaultMessage: 'trong ngày',
  },
  dayBefore: {
    id: `${scope}.dayBefore`,
    defaultMessage: 'trước {n} ngày',
  },
  daysBefore: {
    id: `${scope}.daysBefore`,
    defaultMessage: 'trước {n} ngày',
  },
  COD: {
    id: `${scope}.COD`,
    defaultMessage: 'Thanh toán khi nhận hàng',
  },
  DEBT_7_DAY: {
    id: `${scope}.DEBT_7_DAY`,
    defaultMessage: 'Công nợ 7 ngày',
  },
  DEBT_15_DAY: {
    id: `${scope}.DEBT_15_DAY`,
    defaultMessage: 'Công nợ 15 ngày',
  },
  DEBT_1_MONTH: {
    id: `${scope}.DEBT_1_MONTH`,
    defaultMessage: 'Công nợ 1 tháng',
  },
  BANK_TRANSFER: {
    id: `${scope}.BANK_TRANSFER`,
    defaultMessage: 'Chuyển khoản',
  },
  DEPOSIT: {
    id: `${scope}.DEPOSIT`,
    defaultMessage: 'Trừ tiền cọc',
  },
  DEBT: {
    id: `${scope}.DEBT`,
    defaultMessage: 'Công nợ',
  },
  COD_AND_BANK_TRANSFER: {
    id: `${scope}.COD_AND_BANK_TRANSFER`,
    defaultMessage: 'Tiền mặt và chuyển khoản',
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: 'sản phẩm',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'vi',
  },
  saveSuccess: {
    id: `${scope}.saveSuccess`,
    defaultMessage: 'Lưu thành công',
  },
  saveFailed: {
    id: `${scope}.saveFailed`,
    defaultMessage: 'Lưu thất bại',
  },
  ORDER_PLACE: {
    id: `${scope}.ORDER_PLACE`,
    defaultMessage: 'Tạo đơn hàng',
  },
  ORDER_ITEM_SET_PRICE: {
    id: `${scope}.ORDER_ITEM_SET_PRICE`,
    defaultMessage: 'Cập nhật giá',
  },
  ORDER_ITEM_SET_QUANTITY: {
    id: `${scope}.ORDER_ITEM_SET_QUANTITY`,
    defaultMessage: 'Cập nhật số lượng',
  },
  ORDER_APPROVE: {
    id: `${scope}.ORDER_APPROVE`,
    defaultMessage: 'Duyệt đơn hàng',
  },
  ORDER_ACCEPT: {
    id: `${scope}.ORDER_ACCEPT`,
    defaultMessage: 'Chấp nhận đơn hàng',
  },
  ORDER_CANCEL: {
    id: `${scope}.ORDER_CANCEL`,
    defaultMessage: 'Huỷ đơn hàng',
  },
  ORDER_DELIVERY_CONFIRM: {
    id: `${scope}.ORDER_DELIVERY_CONFIRM`,
    defaultMessage: 'Xác nhận đơn hàng',
  },
  ORDER_VIEW: {
    id: `${scope}.ORDER_VIEW`,
    defaultMessage: 'Xem chi tiết đơn hàng',
  },
  ORDER_LIST: {
    id: `${scope}.ORDER_LIST`,
    defaultMessage: 'Xem danh sách đơn hàng',
  },
  BUYER_FAVORITE_ITEM_ADD: {
    id: `${scope}.BUYER_FAVORITE_ITEM_ADD`,
    defaultMessage: 'Thêm sản phẩm vào yêu thích',
  },
  BUYER_FAVORITE_ITEM_LIST: {
    id: `${scope}.BUYER_FAVORITE_ITEM_LIST`,
    defaultMessage: 'Xem danh sách sản phẩm yêu thích',
  },
  BUYER_USER_ADD: {
    id: `${scope}.BUYER_USER_ADD`,
    defaultMessage: 'Thêm nhân viên',
  },
  BUYER_USER_LIST: {
    id: `${scope}.BUYER_USER_LIST`,
    defaultMessage: 'Xem danh sách nhân viên',
  },
  BUYER_GROUP_ADD: {
    id: `${scope}.BUYER_GROUP_ADD`,
    defaultMessage: 'Tạo nhóm',
  },
  BUYER_GROUP_EDIT: {
    id: `${scope}.BUYER_GROUP_EDIT`,
    defaultMessage: 'Cập nhận nhóm',
  },
  BUYER_GROUP_LIST: {
    id: `${scope}.BUYER_GROUP_LIST`,
    defaultMessage: 'Xem danh sách nhóm',
  },

  ORDER_PLACE_SUB: {
    id: `${scope}.ORDER_PLACE_SUB`,
    defaultMessage: 'Thêm sản phẩm vào giỏ hàng và tao đơn hàng',
  },
  ORDER_ITEM_SET_PRICE_SUB: {
    id: `${scope}.ORDER_ITEM_SET_PRICE_SUB`,
    defaultMessage: 'Cập nhật giá',
  },
  ORDER_ITEM_SET_QUANTITY_SUB: {
    id: `${scope}.ORDER_ITEM_SET_QUANTITY_SUB`,
    defaultMessage: 'Cập nhật số lượng',
  },
  ORDER_APPROVE_SUB: {
    id: `${scope}.ORDER_APPROVE_SUB`,
    defaultMessage: 'Duyệt đơn hàng',
  },
  ORDER_ACCEPT_SUB: {
    id: `${scope}.ORDER_ACCEPT_SUB`,
    defaultMessage: 'Chấp nhận đơn hàng',
  },
  ORDER_CANCEL_SUB: {
    id: `${scope}.ORDER_CANCEL_SUB`,
    defaultMessage: 'Huỷ đơn hàng',
  },
  ORDER_DELIVERY_CONFIRM_SUB: {
    id: `${scope}.ORDER_DELIVERY_CONFIRM_SUB`,
    defaultMessage: 'Xác nhận đơn hàng',
  },
  ORDER_VIEW_SUB: {
    id: `${scope}.ORDER_VIEW_SUB`,
    defaultMessage: 'Xem chi tiết đơn hàng',
  },
  ORDER_LIST_SUB: {
    id: `${scope}.ORDER_LIST_SUB`,
    defaultMessage: 'Xem danh sách đơn hàng',
  },
  BUYER_FAVORITE_ITEM_ADD_SUB: {
    id: `${scope}.BUYER_FAVORITE_ITEM_ADD_SUB`,
    defaultMessage: 'Thêm sản phẩm vào yêu thích',
  },
  BUYER_FAVORITE_ITEM_LIST_SUB: {
    id: `${scope}.BUYER_FAVORITE_ITEM_LIST_SUB`,
    defaultMessage: 'Xem danh sách sản phẩm yêu thích',
  },
  BUYER_USER_ADD_SUB: {
    id: `${scope}.BUYER_USER_ADD_SUB`,
    defaultMessage: 'Thêm nhân viên',
  },
  BUYER_USER_LIST_SUB: {
    id: `${scope}.BUYER_USER_LIST_SUB`,
    defaultMessage: 'Xem danh sách nhân viên',
  },
  BUYER_GROUP_ADD_SUB: {
    id: `${scope}.BUYER_GROUP_ADD_SUB`,
    defaultMessage: 'Tạo nhóm',
  },
  BUYER_GROUP_EDIT_SUB: {
    id: `${scope}.BUYER_GROUP_EDIT_SUB`,
    defaultMessage: 'Cập nhận nhóm',
  },
  BUYER_GROUP_LIST_SUB: {
    id: `${scope}.BUYER_GROUP_LIST_SUB`,
    defaultMessage: 'Xem danh sách nhóm',
  },
  deleteFailed: {
    id: `${scope}.deleteFailed`,
    defaultMessage: 'Delete failed',
  },
  deleteSuccess: {
    id: `${scope}.deleteSuccess`,
    defaultMessage: 'Delete success',
  },
  edit: {
    id: `${scope}.edit`,
    defaultMessage: 'Sửa',
  },
  approve: {
    id: `${scope}.approve`,
    defaultMessage: 'Duyệt',
  },
  decline: {
    id: `${scope}.decline`,
    defaultMessage: 'Không duyệt',
  },
  selectAll: {
    id: `${scope}.selectAll`,
    defaultMessage: 'Chọn tất cả',
  },
  priceExclVat: {
    id: `${scope}.priceExclVat`,
    defaultMessage: 'Giá (không VAT)',
  },
  decimalWithOneNumber: {
    id: `${scope}.decimalWithOneNumber`,
    defaultMessage: 'Chúng tôi chỉ hỗ trợ số nhị phân 1 chữ số',
  },
  newTag: {
    id: `${scope}.newTag`,
    defaultMessage: 'Mới',
  },
  bookInAdvanceTag: {
    id: `${scope}.bookInAdvanceTag`,
    defaultMessage: 'Đặt Trước',
  },
  bookInAdvanceDescription: {
    id: `${scope}.bookInAdvanceDescription`,
    defaultMessage: 'Sản phẩm này sẽ được giao khi có hàng. Vui lòng kiểm tra mô tả để biết ngày dự kiến nhận hàng',
  },
  titleRemoveNote: {
    id: `${scope}.titleRemoveNote`,
    defaultMessage: 'Bạn muốn xoá ghi chú cho sản phẩm này?',
  },
  noteRemoveNote: {
    id: `${scope}.noteRemoveNote`,
    defaultMessage: 'Hành động này không thể hoàn tác.',
  },
  addItemNoteSuccess: {
    id: `${scope}.addItemNoteSuccess`,
    defaultMessage: 'Thêm ghi chú thành công',
  },
  deleteItemNoteSuccess: {
    id: `${scope}.deleteItemNoteSuccess`,
    defaultMessage: 'Xoá ghi chú thành công',
  },
  addItemNoteFailed: {
    id: `${scope}.addItemNoteFailed`,
    defaultMessage: 'Thêm ghi chú thất bại',
  },
  deleteItemNoteFailed: {
    id: `${scope}.deleteItemNoteFailed`,
    defaultMessage: 'Xoá ghi chú thất bại',
  },
  remindNotificationPermission: {
    id: `${scope}.remindNotificationPermission`,
    defaultMessage: 'Đừng bỏ lỡ những cập nhật mới nhất từ Kamereo, hãy bật thông báo ở đây!',
  },
  seeAll: {
    id: `${scope}.seeAll`,
    defaultMessage: 'Xem tất cả',
  },
  today: {
    id: `${scope}.today`,
    defaultMessage: 'Hôm nay',
  },
  yesterday: {
    id: `${scope}.yesterday`,
    defaultMessage: 'Hôm qua',
  },
  orders: {
    id: `${scope}.orders`,
    defaultMessage: 'Lịch sử đơn hàng',
  },
  shop: {
    id: `${scope}.shop`,
    defaultMessage: 'Chợ',
  },
  ordersMobileDisplay: {
    id: `${scope}.ordersMobileDisplay`,
    defaultMessage: 'Đơn hàng',
  },
  accountMobileDisplay: {
    id: `${scope}.accountMobileDisplay`,
    defaultMessage: 'Tài khoản',
  },
  ordersConfirmMobileDisplay: {
    id: `${scope}.ordersConfirmMobileDisplay`,
    defaultMessage: 'Vui lòng kiểm tra và xác nhận đơn hàng',
  },
  orderHistory: {
    id: `${scope}.orderHistory`,
    defaultMessage: 'Lịch sử đơn hàng',
  },
  businessInformation: {
    id: `${scope}.businessInformation`,
    defaultMessage: 'Thông tin công ty',
  },
  businessSettings: {
    id: `${scope}.businessSettings`,
    defaultMessage: 'Thiết lập doanh nghiệp',
  },
  overviewReport: {
    id: `${scope}.overviewReport`,
    defaultMessage: 'Báo cáo tổng quan',
  },
  backToHome: {
    id: `${scope}.backToHome`,
    defaultMessage: 'Trở về trang chủ',
  },
  notification: {
    id: `${scope}.notification`,
    defaultMessage: 'Thông báo',
  },
  productDetailImage: {
    id: `${scope}.productDetailImage`,
    defaultMessage: 'Hình chi tiết sản phẩm',
  },
  searchResult: {
    id: `${scope}.searchResult`,
    defaultMessage: 'Kết quả tìm kiếm',
  },
  howDidYouHearUs: {
    id: `${scope}.howDidYouKnowUs`,
    defaultMessage: 'Bạn biết đến Kamereo từ đâu?',
  },
  otherWebsite: {
    id: `${scope}.otherWebsite`,
    defaultMessage: 'Website khác (tin tức/ diễn đàn…)',
  },
  kamereoSalesman: {
    id: `${scope}.kamereoSalesman`,
    defaultMessage: 'Nhân viên của Kamereo',
  },
  fromAcquaintance: {
    id: `${scope}.fromAcquaintance`,
    defaultMessage: 'Từ Bạn bè/ Đồng nghiệp/ Người quen',
  },
  OOHAds: {
    id: `${scope}.OOHAds`,
    defaultMessage: 'Quảng cáo ngoài trời (Quảng cáo trên xe shipper…)',
  },
  offlineEvent: {
    id: `${scope}.offlineEvent`,
    defaultMessage: 'Sự kiện offline',
  },
  other: {
    id: `${scope}.other`,
    defaultMessage: 'Khác',
  },
  acquisitionSourceValidate: {
    id: `${scope}.acquisitionSourceValidate`,
    defaultMessage: 'Chia sẻ của bạn giúp chúng tôi cải thiện dịch vụ.',
  },
  otherAcquisitionSourceValidate: {
    id: `${scope}.otherAcquisitionSourceValidate`,
    defaultMessage: 'Vui lòng ghi rõ bạn đã biết đến Kamereo từ đâu.',
  },
  acquisitionSourcePlaceHolder: {
    id: `${scope}.acquisitionSourcePlaceHolder`,
    defaultMessage: 'Vui lòng lựa chọn.',
  },
  sameDayDelivery: {
    id: `${scope}.sameDayDelivery`,
    defaultMessage: 'Giao hàng trong ngày',
  },
  sameDayDeliveryTitle: {
    id: `${scope}.sameDayDeliveryTitle`,
    defaultMessage: 'Giao hàng trong ngày',
  },
  iUnderstand: {
    id: `${scope}.iUnderstand`,
    defaultMessage: 'Tôi đã hiểu',
  },
  notice: {
    id: `${scope}.notice`,
    defaultMessage: 'Chú ý',
  },
  changeDay: {
    id: `${scope}.changeDay`,
    defaultMessage: 'Đổi ngày',
  },
  confirmSamDayDelivery: {
    id: `${scope}.confirmSamDayDelivery`,
    defaultMessage: 'Các đơn hàng giao trong ngày không cam kết về số lượng hàng hóa cũng như thời gian giao hàng.',
  },
  orderCutOffTime: {
    id: `${scope}.orderCutOffTime`,
    defaultMessage: 'Thời gian chốt đơn hàng',
  },
  deliveryTimeSameDay: {
    id: `${scope}.deliveryTimeSameDay`,
    defaultMessage: 'Thời gian giao hàng',
  },
  fullfillment: {
    id: `${scope}.fullfillment`,
    defaultMessage: 'Số lượng sản phẩm',
  },
  orderCutOffTimeContent: {
    id: `${scope}.orderCutOffTimeContent`,
    defaultMessage: 'Đặt đơn trước 10:00 sáng để có thể chọn giao hàng trong ngày.',
  },
  deliveryTimeSameDayContent: {
    id: `${scope}.deliveryTimeSameDayContent`,
    defaultMessage: 'Thời gian giao hàng sớm nhất là 3 tiếng từ khi đơn hàng được tạo.',
  },
  fullfillmentContent: {
    id: `${scope}.fullfillmentContent`,
    defaultMessage:
      'Tỉ lệ giao đủ hàng của đơn giao trong cùng ngày sẽ phụ thuộc vào số lượng đặt hàng và số lượng tồn kho hiện tại.',
  },
  reloadPageMessage: {
    id: `${scope}.reloadPageMessage`,
    defaultMessage:
      'Phiên bản mới của trang web chúng tôi đã sẵn sàng. Bạn có muốn tải lại trang để trải nghiệm những cập nhật mới nhất không?',
  },
  exclusive: {
    id: `${scope}.exclusive`,
    defaultMessage: 'Độc quyền',
  },
  onlyForSpecialBusiness: {
    id: `${scope}.onlyForSpecialBusiness`,
    defaultMessage: 'Bán cho Doanh nghiệp đặc biệt',
  },
  onlyForSpecialBusinessDetail: {
    id: `${scope}.onlyForSpecialBusinessDetail`,
    defaultMessage: 'Sản phẩm này được bán độc quyền cho Doanh nghiệp đặc biệt.',
  },
  talkToSale: {
    id: `${scope}.talkToSale`,
    defaultMessage: 'Liên hệ mua hàng',
  },
  kamereoBrand: {
    id: `${scope}.kamereoBrand`,
    defaultMessage: 'Thương hiệu Kamereo',
  },
  kamereoBrandSubText: {
    id: `${scope}.kamereoBrandSubText`,
    defaultMessage: 'Tiện lợi, tiết kiệm',
  },
  gyomuSuper: {
    id: `${scope}.gyomuSuper`,
    defaultMessage: 'Gyomu Japan',
  },
  gyomuSuperSubText: {
    id: `${scope}.gyomuSuperSubText`,
    defaultMessage: 'Thế giới hàng Nhật nội địa',
  },
  combo: {
    id: `${scope}.combo`,
    defaultMessage: 'Combo',
  },
  comboSubText: {
    id: `${scope}.comboSubText`,
    defaultMessage: 'Mua nhiều giá tốt',
  },
  dalatVeggies: {
    id: `${scope}.dalatVeggies`,
    defaultMessage: 'Rau củ Đà Lạt',
  },
  dalatVeggiesSubText: {
    id: `${scope}.dalatVeggiesSubText`,
    defaultMessage: 'Tươi ngon mỗi ngày',
  },
  trustedBrands: {
    id: `${scope}.trustedBrands`,
    defaultMessage: 'Thương hiệu uy tín',
  },
  viewAllBrands: {
    id: `${scope}.viewAllBrands`,
    defaultMessage: 'Xem tất cả thương hiệu',
  },
  commingSoon: {
    id: `${scope}.commingSoon`,
    defaultMessage: 'Sắp ra mắt',
  },
  commingSoonMessage: {
    id: `${scope}.commingSoonMessage`,
    defaultMessage: 'Kamereo sẽ mang đến hàng trăm sản phẩm nội địa Nhật chất lượng cao',
  },
  somethingChanged: {
    id: `${scope}.somethingChanged`,
    defaultMessage: 'Sản phẩm trong giỏ hàng đã thay đổi',
  },
  somethingChangedDescription: {
    id: `${scope}.somethingChangedDescription`,
    defaultMessage: 'Một số sản phẩm trong giỏ hàng của bạn đã thay đổi. Vui lòng kiểm tra giỏ hàng và thử lại',
  },
  goToCart: {
    id: `${scope}.goToCart`,
    defaultMessage: 'Xem lại giỏ hàng',
  },
  brandName: {
    id: `${scope}.brandName`,
    defaultMessage: 'Thương hiệu',
  },
  KAMEREO_VEGGIES: {
    id: `${scope}.KAMEREO_VEGGIES`,
    defaultMessage: 'Rau, Củ, Quả Thương Hiệu Kamereo',
  },
  KAMEREO_ECO: {
    id: `${scope}.KAMEREO_ECO`,
    defaultMessage: 'Sản Phẩm Thân Thiện Môi Trường Thương Hiệu Kamereo',
  },
  KAMEREO_DAILY: {
    id: `${scope}.KAMEREO_DAILY`,
    defaultMessage: 'Sản Phẩm Tiện Lợi, Tiết Kiệm Thương Hiệu Kamereo',
  },
  RAU_CU_TUOI_SACH: {
    id: `${scope}.RAU_CU_TUOI_SACH`,
    defaultMessage: 'Rau Củ Tươi Sạch',
  },
  WEEKLY_CAMPAIGN: {
    id: `${scope}.WEEKLY_CAMPAIGN`,
    defaultMessage: 'Tuần Lễ Ưu Đãi',
  },
  BUDGET_FRIENDLY: {
    id: `${scope}.BUDGET_FRIENDLY`,
    defaultMessage: 'Mua Hàng Tiết Kiệm',
  },
  businessType: {
    id: `${scope}.businessType`,
    defaultMessage: 'Loại hình kinh doanh',
  },
  businessCategory: {
    id: `${scope}.businessCategory`,
    defaultMessage: 'Doanh mục kinh doanh',
  },
  businessCategoryPlaceHolder: {
    id: `${scope}.businessCategoryPlaceHolder`,
    defaultMessage: 'Chọn doanh mục',
  },
  businessTypePlaceHolder: {
    id: `${scope}.businessTypePlaceHolder`,
    defaultMessage: 'Chọn loại hình',
  },
  province: {
    id: `${scope}.province`,
    defaultMessage: 'Tỉnh/Thành phố',
  },
  newDistrict: {
    id: `${scope}.newDistrict`,
    defaultMessage: 'Quận/Huyện',
  },
  newWard: {
    id: `${scope}.newWard`,
    defaultMessage: 'Phường/Xã',
  },
  newAddress: {
    id: `${scope}.newAddress`,
    defaultMessage: 'Địa chỉ cụ thể',
  },
  roleAtBusiness: {
    id: `${scope}.roleAtBusiness`,
    defaultMessage: 'Vai trò tại doanh nghiệp',
  },
  provincePlaceHolder: {
    id: `${scope}.provincePlaceHolder`,
    defaultMessage: 'Chọn tỉnh thành phố',
  },
  districtPlaceHolder: {
    id: `${scope}.districtPlaceHolder`,
    defaultMessage: 'Chọn quận huyện',
  },
  wardPlaceHolder: {
    id: `${scope}.wardPlaceHolder`,
    defaultMessage: 'Chọn phường xã',
  },
  addressPlaceHolder: {
    id: `${scope}.addressPlaceHolder`,
    defaultMessage: 'Số nhà, tên đường, phường xã...',
  },
  rolePlaceHolder: {
    id: `${scope}.rolePlaceHolder`,
    defaultMessage: 'Chọn vai trò',
  },
  representativeName: {
    id: `${scope}.representativeName`,
    defaultMessage: 'Tên người đại diện',
  },
  linkHubspot: {
    id: `${scope}.linkHubspot`,
    defaultMessage: 'Link Hubspot',
  },
  linkHubspotPlaceHolder: {
    id: `${scope}.linkHubspotPlaceHolder`,
    defaultMessage: 'Nhập link hubspot doanh nghiệp',
  },
  companyWebsite: {
    id: `${scope}.companyWebsite`,
    defaultMessage: 'ShopeeFood',
  },
  shoppeeFoodValidate: {
    id: `${scope}.shoppeeFoodValidate`,
    defaultMessage: 'Link ShoppeeFood phải bắt đầu bằng https://shopeefood.vn/',
  },
  companyWebsitePlaceHolder: {
    id: `${scope}.companyWebsitePlaceHolder`,
    defaultMessage: 'Nhập link ShopeeFood',
  },
  numberOfBranches: {
    id: `${scope}.numberOfBranches`,
    defaultMessage: 'Số chi nhánh',
  },
  numberOfBranchesPlaceHolder: {
    id: `${scope}.numberOfBranchesPlaceHolder`,
    defaultMessage: 'Nhập số chi nhánh',
  },
  hourOfOperation: {
    id: `${scope}.hourOfOperation`,
    defaultMessage: 'Giờ hoạt động',
  },
  hourOfOperationPlaceHolderOpen: {
    id: `${scope}.hourOfOperationPlaceHolderOpen`,
    defaultMessage: 'Mở cửa',
  },
  hourOfOperationPlaceHolderClose: {
    id: `${scope}.hourOfOperationPlaceHolderClose`,
    defaultMessage: 'Đóng cửa',
  },
  priorityLevel: {
    id: `${scope}.priorityLevel`,
    defaultMessage: 'Độ ưu tiên khách hàng',
  },
  priorityLevelPlaceHolder: {
    id: `${scope}.priorityLevelPlaceHolder`,
    defaultMessage: 'Chọn độ ưu tiên',
  },
  team: {
    id: `${scope}.team`,
    defaultMessage: 'Nhóm',
  },
  teamPlaceHolder: {
    id: `${scope}.teamPlaceHolder`,
    defaultMessage: 'Chọn nhóm',
  },
  salePIC: {
    id: `${scope}.salePIC`,
    defaultMessage: 'Sale PIC',
  },
  salePICPlaceHolder: {
    id: `${scope}.salePICPlaceHolder`,
    defaultMessage: 'Chọn Sale PIC',
  },
  salePhone: {
    id: `${scope}.SĐT Sale`,
    defaultMessage: 'SĐT Sale',
  },
  storeNamePlaceHolder: {
    id: `${scope}.storeNamePlaceHoler`,
    defaultMessage: 'Input your store name',
  },
  phonePlaceHolder: {
    id: `${scope}.phonePlaceHolder`,
    defaultMessage: 'Input your phone number',
  },
  storeConfimSubText: {
    id: `${scope}.storeConfimSubText`,
    defaultMessage: 'Hãy đảm bảo địa chỉ cửa hàng và số điện thoại là chính xác để Shipper liên hệ giao hàng.',
  },
  updateStoreAddress: {
    id: `${scope}.updateStoreAddress`,
    defaultMessage: 'Cập nhật địa chỉ cửa hàng',
  },
  storeNoteText: {
    id: `${scope}.storeNoteText`,
    defaultMessage:
      'Bạn không thể tự cập nhật thông tin sau khi lưu. Vui lòng kiểm tra chính xác, Shipper sẽ giao hàng theo Địa chỉ, SĐT trên.',
  },
  updateStoreNoteText: {
    id: `${scope}.updateStoreNoteText`,
    defaultMessage: 'Bạn không thể tự chỉnh sửa sau khi lưu. Nếu cần thay đổi, vui lòng liên hệ bộ phận kinh doanh.',
  },
  createStoreSuccessfully: {
    id: `${scope}.createStoreSuccessfully`,
    defaultMessage: 'Xác nhận cửa hàng thành công',
  },
  createStoreFailure: {
    id: `${scope}.createStoreFailure`,
    defaultMessage: 'Xác nhận cửa hàng không thành công',
  },
  updateStoreSuccessfully: {
    id: `${scope}.updateStoreSuccessfully`,
    defaultMessage: 'Cập nhật cửa hàng thành công',
  },
  updateStoreFailure: {
    id: `${scope}.updateStoreFailure`,
    defaultMessage: 'Cập nhật cửa hàng không thành công',
  },
  shopByBrand: {
    id: `${scope}.shopByBrand`,
    defaultMessage: 'Tất cả thương hiệu',
  },
  selectRegionToViewPrices: {
    id: `${scope}.selectRegionToViewPrices`,
    defaultMessage: 'Chọn khu vực để xem giá',
  },
  getTheBestPriceForYourBusiness: {
    id: `${scope}.getTheBestPriceForYourBusiness`,
    defaultMessage: 'Nhận giá tốt nhất cho doanh nghiệp của bạn',
  },
  northern: {
    id: `${scope}.northern`,
    defaultMessage: 'Miền Bắc',
  },
  southern: {
    id: `${scope}.southern`,
    defaultMessage: 'Miền Nam',
  },
  continue: {
    id: `${scope}.continue`,
    defaultMessage: 'Tiếp tục',
  },
  region: {
    id: `${scope}.region`,
    defaultMessage: 'Khu vực',
  },
  HCM: {
    id: `${scope}.HCM`,
    defaultMessage: 'miền Nam',
  },
  HN: {
    id: `${scope}.HN`,
    defaultMessage: 'miền Bắc',
  },
  backToTop: {
    id: `${scope}.backToTop`,
    defaultMessage: 'Về đầu trang',
  },
  validatePhone: {
    id: `${scope}.validatePhone`,
    defaultMessage: 'Số điện thoại không hợp lệ',
  },
  requestNewProductTitle: {
    id: `${scope}.requestNewProductTitle`,
    defaultMessage: 'Yêu cầu bán thêm sản phẩm',
  },
  requestNewProductSubTitle: {
    id: `${scope}.requestNewProductSubTitle`,
    defaultMessage: 'Bằng cách điền vào form này chúng tôi sẽ nhận được thông tin về sản phẩm bạn cần mua',
  },
  requestProductName: {
    id: `${scope}.requestProductName`,
    defaultMessage: 'Tên sản phẩm',
  },
  requestProductLinkRef: {
    id: `${scope}.requestProductLinkRef`,
    defaultMessage: 'Link tham khảo sản phẩm (không bắt buộc)',
  },
  requestProductPhoneNumber: {
    id: `${scope}.requestProductPhoneNumber`,
    defaultMessage: 'Số điện thoại (không bắt buộc)',
  },
  requestProductNamePlaceHolder: {
    id: `${scope}.requestProductNamePlaceHolder`,
    defaultMessage: 'Nhập tên sản phẩm',
  },
  requestProductLinkRefPlaceHolder: {
    id: `${scope}.requestProductLinkRefPlaceHolder`,
    defaultMessage: 'Nhập link',
  },
  requestProductPhoneNumberPlaceHolder: {
    id: `${scope}.requestProductPhoneNumberPlaceHolder`,
    defaultMessage: 'Nhập số điện thoại',
  },
  sendRequest: {
    id: `${scope}.sendRequest`,
    defaultMessage: 'Gửi yêu cầu',
  },
  checkboxRequest: {
    id: `${scope}.checkboxRequest`,
    defaultMessage: 'Nhận thông báo qua số điện thoại khi có hàng',
  },
  sendRequestSuccess: {
    id: `${scope}.sendRequestSuccess`,
    defaultMessage: 'Gửi yêu cầu bán thêm sản phẩm thành công',
  },
  sendRequestFail: {
    id: `${scope}.sendRequestFail`,
    defaultMessage: 'Gửi yêu cầu bán thêm sản phẩm thất bại',
  },
  duplicateStoreError: {
    id: `${scope}.duplicateStoreError`,
    defaultMessage: 'Thông tin cửa hàng vừa tạo bị trùng thông tin với cửa hàng đã từng tồn tại',
  },
  phoneNumber: {
    id: `${scope}.phoneNumber`,
    defaultMessage: 'SĐT',
  },
  serviceFee: {
    id: `${scope}.serviceFee`,
    defaultMessage: 'Phí dịch vụ',
  },
  freeServiceFee: {
    id: `${scope}.freeServiceFee`,
    defaultMessage: 'Giảm giá dịch vụ',
  },
  freeShippingTitle: {
    id: `${scope}.freeShippingTitle`,
    defaultMessage: 'Đơn hàng của bạn sẽ được',
  },
  freeShippingContent: {
    id: `${scope}.freeShippingContent`,
    defaultMessage: 'Miễn phí dịch vụ 🎉',
  },
  freeShippingText: {
    id: `${scope}.freeShippingText`,
    defaultMessage: 'Miễn phí dịch vụ',
  },
  totalDiscount: {
    id: `${scope}.totalDiscount`,
    defaultMessage: 'Bạn đã tiết kiệm được {discount}đ',
  },
  buyMore: {
    id: `${scope}.buyMore`,
    defaultMessage: 'Mua thêm',
  },
  canOrder: {
    id: `${scope}.canOrder`,
    defaultMessage: 'để có thể đặt hàng!',
  },
  toGetFreeService: {
    id: `${scope}.toGetFreeService`,
    defaultMessage: 'để được miễn phí dịch vụ!',
  },
  placeOrder: {
    id: `${scope}.placeOrder`,
    defaultMessage: 'Đặt hàng',
  },
  subTotal: {
    id: `${scope}.subTotal`,
    defaultMessage: 'Tổng tiền hàng (trước VAT)',
  },
  promotion: {
    id: `${scope}.promotion`,
    defaultMessage: 'Khuyến mãi',
  },
  youCanPlaceAnOrder: {
    id: `${scope}.youCanPlaceAnOrder`,
    defaultMessage: 'Bạn có thể đặt hàng!',
  },
  conditionForFreeService: {
    id: `${scope}.conditionForFreeService`,
    defaultMessage: 'Điều kiện được miễn phí dịch vụ',
  },
  conditionForFreeServiceContent: {
    id: `${scope}.conditionForFreeServiceContent`,
    defaultMessage: 'Cửa hàng nằm trong phạm vi hỗ trợ của Kamereo và đơn hàng phải trên {amount}đ.',
  },
  iGotIt: {
    id: `${scope}.iGotIt`,
    defaultMessage: 'Tôi đã hiểu',
  },
  voucherMobile: {
    id: `${scope}.voucherMobile`,
    defaultMessage: 'Mua hàng trên ứng dụng Kamereo để sử dụng ưu đãi',
  },
  removeVoucher: {
    id: `${scope}.removeVoucher`,
    defaultMessage: 'Xóa voucher',
  },
  viewVoucher: {
    id: `${scope}.viewVoucher`,
    defaultMessage: 'Xem voucher',
  },
  voucherConfirmTitle: {
    id: `${scope}.voucherConfirmTitle`,
    defaultMessage: 'Áp dụng voucher không thành công',
  },
  voucherConfirmContent: {
    id: `${scope}.voucherConfirmContent`,
    defaultMessage: 'Sản phẩm trong giỏ hàng của bạn đã thay đổi. Đơn hàng chưa đủ điều kiện áp dụng Voucher',
  },
  priceAfterDiscount: {
    id: `${scope}.priceAfterDiscount`,
    defaultMessage: 'Đơn giá sau giảm',
  },
  totalAfterDiscountInclVAT: {
    id: `${scope}.totalAfterDiscountInclVAT`,
    defaultMessage: 'Tổng tiền sau giảm giá (có VAT)',
  },
  recommendedProducts: {
    id: `${scope}.recommendedProducts`,
    defaultMessage: 'Sản phẩm đề xuất',
  },
  discoverMore: {
    id: `${scope}.discoverMore`,
    defaultMessage: 'Khám phá thêm',
  },
  dvt: {
    id: `${scope}.dvt`,
    defaultMessage: 'ĐVT',
  },
  BAR_PUB: {
    id: `${scope}.BAR_PUB`,
    defaultMessage: 'Bar - Pub',
  },
  NIGHT_CLUB: {
    id: `${scope}.NIGHT_CLUB`,
    defaultMessage: 'Hộp Đêm',
  },
  CAFE_BAKERY_INDEPENDENT: {
    id: `${scope}.CAFE_BAKERY_INDEPENDENT`,
    defaultMessage: 'Quán Cà Phê - Bánh',
  },
  CAFE_BAKERY_CHAIN: {
    id: `${scope}.CAFE_BAKERY_CHAIN`,
    defaultMessage: 'Chuỗi Cà Phê - Bánh',
  },
  CATERING_AND_CANTEEN: {
    id: `${scope}.CATERING_AND_CANTEEN`,
    defaultMessage: 'Căn Tin',
  },
  FACTORY: {
    id: `${scope}.FACTORY`,
    defaultMessage: 'Nhà Máy',
  },
  SCHOOL: {
    id: `${scope}.SCHOOL`,
    defaultMessage: 'Trường Học',
  },
  HOSPITAL: {
    id: `${scope}.HOSPITAL`,
    defaultMessage: 'Bệnh Viện',
  },
  OFFICE: {
    id: `${scope}.OFFICE`,
    defaultMessage: 'Văn Phòng',
  },
  GYM: {
    id: `${scope}.GYM`,
    defaultMessage: 'Gym',
  },
  CONVENTION_CENTER: {
    id: `${scope}.CONVENTION_CENTER`,
    defaultMessage: 'Trung Tâm Hội Nghị - Tiệc Cưới',
  },
  HOTEL_1_3_STAR: {
    id: `${scope}.HOTEL_1_3_STAR`,
    defaultMessage: 'Khách Sạn 1 - 3 Sao',
  },
  HOTEL_4_5_STAR: {
    id: `${scope}.HOTEL_4_5_STAR`,
    defaultMessage: 'Khách Sạn 4 - 5 Sao',
  },
  HOTEL_NORMAL: {
    id: `${scope}.HOTEL_NORMAL`,
    defaultMessage: 'Khách Sạn Bình Dân',
  },
  CONVENIENT_STORE: {
    id: `${scope}.CONVENIENT_STORE`,
    defaultMessage: 'Cửa Hàng Tiện Lợi',
  },
  SUPER_MARKET: {
    id: `${scope}.SUPER_MARKET`,
    defaultMessage: 'Siêu Thị',
  },
  FINE_RETAIL: {
    id: `${scope}.FINE_RETAIL`,
    defaultMessage: 'Fine Retail',
  },
  TRADITIONAL_RETAIL: {
    id: `${scope}.TRADITIONAL_RETAIL`,
    defaultMessage: 'Bán Lẻ Truyền Thống',
  },
  RETAIL_E_COMMERCE: {
    id: `${scope}.RETAIL_E_COMMERCE`,
    defaultMessage: 'Bán Lẻ E-com',
  },
  WHOLESALER: {
    id: `${scope}.WHOLESALER`,
    defaultMessage: 'Bán sỉ',
  },
  RESTAURANT_VIETNAMESE: {
    id: `${scope}.RESTAURANT_VIETNAMESE`,
    defaultMessage: 'Nhà Hàng Việt',
  },
  RESTAURANT_WESTERN: {
    id: `${scope}.RESTAURANT_WESTERN`,
    defaultMessage: 'Nhà Hàng Tây',
  },
  RESTAURANT_JAPANESE: {
    id: `${scope}.RESTAURANT_JAPANESE`,
    defaultMessage: 'Nhà Hàng Nhật Bản',
  },
  RESTAURANT_KOREAN: {
    id: `${scope}.RESTAURANT_KOREAN`,
    defaultMessage: 'Nhà Hàng Hàn Quốc',
  },
  RESTAURANT_CHINESE: {
    id: `${scope}.RESTAURANT_CHINESE`,
    defaultMessage: 'Nhà Hàng Trung Quốc',
  },
  RESTAURANT_THAI: {
    id: `${scope}.RESTAURANT_THAI`,
    defaultMessage: 'Nhà Hàng Thái',
  },
  RESTAURANT_VEGETARIAN: {
    id: `${scope}.RESTAURANT_VEGETARIAN`,
    defaultMessage: 'Nhà Hàng Chay',
  },
  RESTAURANT_CHAIN: {
    id: `${scope}.RESTAURANT_CHAIN`,
    defaultMessage: 'Chuỗi Nhà Hàng',
  },
  TAKE_AWAY_ONLINE_KITCHEN: {
    id: `${scope}.TAKE_AWAY_ONLINE_KITCHEN`,
    defaultMessage: 'Bán Online - Mang Đi',
  },
  DRINK_RESTAURANT: {
    id: `${scope}.DRINK_RESTAURANT`,
    defaultMessage: 'Quán Nhậu',
  },
  FOOD_STORE: {
    id: `${scope}.FOOD_STORE`,
    defaultMessage: 'Quán cơm / Bún / Phở',
  },
  farmToBusiness: {
    id: `${scope}.farmToBusiness`,
    defaultMessage: 'Từ nông trại đến doanh nghiệp',
  },
  promotionKamereo: {
    id: `${scope}.promotionKamereo`,
    defaultMessage: 'Đề xuất',
  },
  promotionKamereoTitle: {
    id: `${scope}.promotionKamereoTitle`,
    defaultMessage: 'Sản phẩm thương hiệu Kamereo',
  },
  promotionKamereoSubTitle: {
    id: `${scope}.promotionKamereoSubTitle`,
    defaultMessage: 'Chuẩn chất lượng, tối ưu chi phí',
  },
  superSavingTag: {
    id: `${scope}.superSavingTag`,
    defaultMessage: 'Siêu tiết kiệm',
  },
  superSavingTagSub: {
    id: `${scope}.superSavingTagSub`,
    defaultMessage: 'Mua nhiều giá tốt',
  },
  viewKamereoLabel: {
    id: `${scope}.viewKamereoLabel`,
    defaultMessage: 'Xem thương hiệu',
  },
  savingAmount: {
    id: `${scope}.savingAmount`,
    defaultMessage: 'Tiết kiệm',
  },
  priceIncludedVat: {
    id: `${scope}.priceIncludedVat`,
    defaultMessage: 'Giá đã bao gồm VAT: {price}',
  },
  priceBeforeVat: {
    id: `${scope}.priceBeforeVat`,
    defaultMessage: 'Đơn giá{break}(Trước VAT)',
  },
  totalBeforeVat: {
    id: `${scope}.totalBeforeVat`,
    defaultMessage: 'Thành tiền{break}(Trước VAT)',
  },
  totalAfterVat: {
    id: `${scope}.totalAfterVat`,
    defaultMessage: 'Thành tiền{break}(Sau VAT)',
  },
  totalBeforeVatME: {
    id: `${scope}.totalBeforeVatME`,
    defaultMessage: 'Tổng trước VAT',
  },
  totalAfterVatME: {
    id: `${scope}.totalAfterVatME`,
    defaultMessage: 'Tổng sau VAT',
  },
  vatOnSubtotal: {
    id: `${scope}.vatOnSubtotal`,
    defaultMessage: 'VAT tiền hàng',
  },
  vatOnServiceFee: {
    id: `${scope}.vatOnServiceFee`,
    defaultMessage: 'VAT phí dịch vụ',
  },
  totalExclVat: {
    id: `${scope}.totalExclVat`,
    defaultMessage: 'Thành tiền{break}(trước VAT)',
  },
  totalIncludedVat: {
    id: `${scope}.totalIncludedVat`,
    defaultMessage: 'Thành tiền{break}(sau VAT)',
  },
  priceExcludedVat: {
    id: `${scope}.priceExcludedVat`,
    defaultMessage: 'Đơn giá{break}(trước VAT)',
  },
  regionalGroup: {
    id: `${scope}.regionalGroup`,
    defaultMessage: 'Nhóm khu vực',
  },
  freeServiceCondition: {
    id: `${scope}.freeServiceCondition`,
    defaultMessage: 'Điều kiện miễn phí dịch vụ',
  },
  ordersOver: {
    id: `${scope}.ordersOver`,
    defaultMessage: 'Đơn hàng ≥',
  },
  productDescription: {
    id: `${scope}.productDescription`,
    defaultMessage: 'Mô tả sản phẩm',
  },
  readMore: {
    id: `${scope}.readMore`,
    defaultMessage: 'Xem thêm',
  },
  receiveTimeEarliest: {
    id: `${scope}.receiveTimeEarliest`,
    defaultMessage: 'Nhận hàng sớm nhất từ',
  },
  securePayment: {
    id: `${scope}.securePayment`,
    defaultMessage: 'Thanh toán khi giao • Miễn phí vận chuyển',
  },
  saveAmount: {
    id: `${scope}.saveAmount`,
    defaultMessage: 'Tiết kiệm',
  },
  removeNote: {
    id: `${scope}.removeNote`,
    defaultMessage: 'Xoá ghi chú',
  },
  deliveryPolicy: {
    id: `${scope}.deliveryPolicy`,
    defaultMessage: 'Chính sách giao hàng',
  },
  paymentPolicy1: {
    id: `${scope}.paymentPolicy1`,
    defaultMessage: '1. Thanh toán khi giao:',
  },
  paymentPolicy1Sub: {
    id: `${scope}.paymentPolicy1Sub`,
    defaultMessage: 'Thanh toán khi nhận hàng (COD)',
  },
  paymentPolicy1SubDesc: {
    id: `${scope}.paymentPolicy1SubDesc`,
    defaultMessage: 'Quý khách có thể thanh toán sau khi đồng kiểm đơn hàng bằng:',
  },
  paymentPolicy1SubDesc1: {
    id: `${scope}.paymentPolicy1SubDesc1`,
    defaultMessage: 'Tiền mặt: Giao trực tiếp cho shipper Kamereo.',
  },
  paymentPolicy1SubDesc2: {
    id: `${scope}.paymentPolicy1SubDesc2`,
    defaultMessage: 'Chuyển khoản: Qua tài khoản ngân hàng được cung cấp.',
  },
  paymentPolicy2: {
    id: `${scope}.paymentPolicy2`,
    defaultMessage: '2. Phí giao hàng',
  },
  paymentPolicy2Sub1Desc1: {
    id: `${scope}.paymentPolicy2Sub1Desc1`,
    defaultMessage: 'Phí dịch vụ chỉ từ',
  },
  paymentPolicy2Sub1Desc2: {
    id: `${scope}.paymentPolicy2Sub1Desc2`,
    defaultMessage: 'áp dụng trên từng lần giao hàng.',
  },
  paymentPolicy2Sub2Desc1: {
    id: `${scope}.paymentPolicy2Sub2Desc1`,
    defaultMessage: 'Kamereo miễn phí giao hàng đối với đơn hàng có giá trị từ',
  },
  paymentPolicy2Sub2Desc2: {
    id: `${scope}.paymentPolicy2Sub2Desc2`,
    defaultMessage: 'hoặc theo khu vực quy định',
  },
  here: {
    id: `${scope}.here`,
    defaultMessage: 'tại đây',
  },
  gotIt: {
    id: `${scope}.gotIt`,
    defaultMessage: 'Tôi đã hiểu',
  },
  similarProducts: {
    id: `${scope}.similarProducts`,
    defaultMessage: 'Sản phẩm tương tự',
  },
  explore: {
    id: `${scope}.explore`,
    defaultMessage: 'Khám phá',
  },
  paymentByUomKg: {
    id: `${scope}.paymentByUomKg`,
    defaultMessage: 'Tính tiền theo cân nặng thực',
  },
  paymentByUomTitle1: {
    id: `${scope}.paymentByUomTitle1`,
    defaultMessage: 'Sản phẩm bán theo Kg là gì?',
  },
  paymentByUomTitle1Desc1: {
    id: `${scope}.paymentByUomTitle1Desc1`,
    defaultMessage: 'Có thể nhập số Kg lẻ, VD: 1.2Kg.',
  },
  paymentByUomTitle1Desc2: {
    id: `${scope}.paymentByUomTitle1Desc2`,
    defaultMessage: 'Một số sản phẩm đặc thù (VD: Cá hồi nguyên con) có quy định số Kg tối thiểu.',
  },
  paymentByUomTitle2: {
    id: `${scope}.paymentByUomTitle2`,
    defaultMessage: 'Thành tiền tính theo số Kg thực giao',
  },
  paymentByUomTitle2Desc1: {
    id: `${scope}.paymentByUomTitle2Desc1`,
    defaultMessage:
      'Trọng lượng giao thực tế có thể chênh lệch so với số Kg bạn đặt, vì việc cân đo trong thực tế thường sẽ có sai số nhỏ:',
  },
  paymentByUomTitle2Desc1SubDesc1: {
    id: `${scope}.paymentByUomTitle2Desc1SubDesc1`,
    defaultMessage: 'Đối với rau củ, chênh lệch khoảng ±50–200g.',
  },
  paymentByUomTitle2Desc1SubDesc2: {
    id: `${scope}.paymentByUomTitle2Desc1SubDesc2`,
    defaultMessage: 'Đối với 1 số sản phẩm đặc thù. VD: Cá hồi nguyên con, chênh lệch có thể giao động nhiều hơn.',
  },
  paymentByUomTitle2Desc2: {
    id: `${scope}.paymentByUomTitle2Desc2`,
    defaultMessage:
      'Dựa trên đơn giá của mỗi Kg, thành tiền sẽ được cập nhật theo số cân nặng thực tế giao. Bạn sẽ được thông báo về thành tiền cuối cùng khi nhận hàng.',
  },
  soldAmount: {
    id: `${scope}.soldAmount`,
    defaultMessage: 'Đã bán',
  },
  bestSeller: {
    id: `${scope}.bestSeller`,
    defaultMessage: 'Bán chạy',
  },
  beforeVat: {
    id: `${scope}.beforeVat`,
    defaultMessage: '(Trước VAT)',
  },
  discount: {
    id: `${scope}.discount`,
    defaultMessage: 'Giảm',
  },
  productReview: {
    id: `${scope}.productReview`,
    defaultMessage: 'Đánh giá sản phẩm',
  },
  review: {
    id: `${scope}.review`,
    defaultMessage: 'Đánh giá',
  },
  stars: {
    id: `${scope}.stars`,
    defaultMessage: 'sao',
  },
  purchased: {
    id: `${scope}.purchased`,
    defaultMessage: 'Đã mua',
  },
  great: {
    id: `${scope}.great`,
    defaultMessage: 'Tuyệt vời',
  },
  good: {
    id: `${scope}.good`,
    defaultMessage: 'Tốt',
  },
  okay: {
    id: `${scope}.okay`,
    defaultMessage: 'Tạm ổn',
  },
  bad: {
    id: `${scope}.bad`,
    defaultMessage: 'Tệ',
  },
  terrible: {
    id: `${scope}.terrible`,
    defaultMessage: 'Kinh khủng',
  },
  writeAReview: {
    id: `${scope}.writeAReview`,
    defaultMessage: 'Viết đánh giá',
  },
  howDoYouFeel: {
    id: `${scope}.howDoYouFeel`,
    defaultMessage: 'Bạn cảm thấy thế nào?',
  },
  addImageVideo: {
    id: `${scope}.addImageVideo`,
    defaultMessage: 'Thêm hình ảnh, video (tối đa 5)',
  },
  anonymousComment: {
    id: `${scope}.anonymousComment`,
    defaultMessage: 'Bình luận chế độ ẩn danh',
  },
  submitReview: {
    id: `${scope}.submitReview`,
    defaultMessage: 'Gửi đi',
  },
  all: {
    id: `${scope}.all`,
    defaultMessage: 'Tất cả',
  },
  noReviewsYet: {
    id: `${scope}.noReviewsYet`,
    defaultMessage: 'Chưa có đánh giá cho sản phẩm này.',
  },
  beTheFirstToReview: {
    id: `${scope}.beTheFirstToReview`,
    defaultMessage: 'Hãy là người đầu tiên chia sẻ nhận xét sau khi đặt hàng.',
  },
  uploadImageFailed: {
    id: `${scope}.uploadImageFailed`,
    defaultMessage: 'Tải ảnh lên thất bại. Vui lòng thử lại.',
  },
  anonymous: {
    id: `${scope}.anonymous`,
    defaultMessage: 'Ẩn danh',
  },
  onlyMp4VideoSupported: {
    id: `${scope}.onlyMp4VideoSupported`,
    defaultMessage: 'Chỉ chấp nhận video định dạng MP4 hoặc MOV.',
  },
  onlyJpgOrPngImageSupported: {
    id: `${scope}.onlyJpgOrPngImageSupported`,
    defaultMessage: 'Chỉ chấp nhận ảnh định dạng .JPG, .JPEG hoặc .PNG',
  },
  maximumUploadFilesLimit: {
    id: `${scope}.maximumUploadFilesLimit`,
    defaultMessage: 'Bạn chỉ có thể tải lên tối đa 5 (ảnh/video).',
  },
  imageSizeLimit: {
    id: `${scope}.imageSizeLimit`,
    defaultMessage: 'Vui lòng chọn ảnh có định dạng hợp lệ và dung lượng không vượt quá 2MB.',
  },
  videoSizeLimit: {
    id: `${scope}.videoSizeLimit`,
    defaultMessage: 'Vui lòng chọn video có dung lượng không vượt quá 20MB.',
  },
  pleaseEnterYourReview: {
    id: `${scope}.pleaseEnterYourReview`,
    defaultMessage: 'Vui lòng nhập đánh giá của bạn',
  },
  reviewMinLength: {
    id: `${scope}.reviewMinLength`,
    defaultMessage: 'Đánh giá phải có ít nhất 10 ký tự',
  },
  reviewMaxLength: {
    id: `${scope}.reviewMaxLength`,
    defaultMessage: 'Đánh giá không được vượt quá 200 ký tự',
  },
  star: {
    id: `${scope}.star`,
    defaultMessage: 'sao',
  },
  signinToReview: {
    id: `${scope}.signinToReview`,
    defaultMessage: 'Đăng nhập để đánh giá.',
  },
});
